import { render, staticRenderFns } from "./LayaWellbeingCourse.vue?vue&type=template&id=1a87b392&scoped=true"
import script from "./LayaWellbeingCourse.vue?vue&type=script&lang=js"
export * from "./LayaWellbeingCourse.vue?vue&type=script&lang=js"
import style0 from "./LayaWellbeingCourse.vue?vue&type=style&index=0&id=1a87b392&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87b392",
  null
  
)

export default component.exports